import { Icon, IconProps } from 'design-system';

export const DotIcon = (props: IconProps) => {
  return (
    <Icon width='8px' height='7px' viewBox='0 0 8 7' fill='gray.500' {...props}>
      <circle cx='4' cy='3.5' r='3.5' fill='inherit' />
    </Icon>
  );
};
